import React from 'react'
export const PlusIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 10 8" fill="currentColor">
      <path d="M5.11538 0.615385C5.11538 0.275 4.84038 0 4.5 0C4.15962 0 3.88462 0.275 3.88462 0.615385V3.38462H1.11538C0.775 3.38462 0.5 3.65962 0.5 4C0.5 4.34038 0.775 4.61538 1.11538 4.61538H3.88462V7.38462C3.88462 7.725 4.15962 8 4.5 8C4.84038 8 5.11538 7.725 5.11538 7.38462V4.61538H7.88462C8.225 4.61538 8.5 4.34038 8.5 4C8.5 3.65962 8.225 3.38462 7.88462 3.38462H5.11538V0.615385Z"
        fill="currentColor" />
    </svg>
  )
}
